import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { provideGlobalGridOptions } from 'ag-grid-community'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-quartz.css'

import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './style.css'

declare const __APP_BUILD_ID__: string

// AG Grid v33+ defaults to Theming API (themeQuartz). We still load classic CSS
// themes (ag-grid.css + ag-theme-quartz). Opt into legacy theming to avoid error #239.
provideGlobalGridOptions({ theme: 'legacy' })

// Drop stale workspace tabs when a new SPA build is loaded (avoids old GenericQueue
// titles/components lingering after deploy of dedicated modules like In Transit Store).
try {
  const buildId = typeof __APP_BUILD_ID__ !== 'undefined' ? String(__APP_BUILD_ID__) : 'dev'
  const key = 'na-next-build-id'
  const prev = sessionStorage.getItem(key)
  if (prev && prev !== buildId) {
    const drop: string[] = []
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i)
      if (k && (k.startsWith('na-next-workspace-tabs') || k === 'na-next-workspace-tabs-v1')) {
        drop.push(k)
      }
    }
    drop.forEach((k) => sessionStorage.removeItem(k))
  }
  sessionStorage.setItem(key, buildId)
  ;(window as unknown as { __NA_NEXT_BUILD__?: string }).__NA_NEXT_BUILD__ = buildId
} catch {
  /* ignore private mode */
}

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(vuetify)

app.mount('#app')
